<template>
	<o-section
		class="temp-worker-task-list"
		:title="`${'Tâche'.pluralize(taskList.length, false)} (${taskList.length})`">
		<template #actions>
			<!-- <o-icon
        v-tooltip="`Supprimer les tâches finies`"
        class="aside-profile__section-action"
        icon="bin-1"
        @click="deleteDoneTasks()"/> -->
			<o-icon
				v-tooltip="`Ajouter une tâche`"
				class="aside-profile__section-action"
				font-icon="icon-interface-add-circle"
				@click="setup.addTaskAsync()"/>
		</template>

		<o-toggle
			v-if="!setup.listIsEmpty"
			v-model="setup.toggleDone"
			class="temp-worker-task-list__toggle"
			label="Afficher les tâches finies"/>

		<p
			v-if="setup.listIsEmpty"
			class="temp-worker-task-list__empty-text">
			<span class="temp-worker-task-list__empty-text-arrow">
				&#10548;
			</span>
			Renseignez une tâche / un pense-bête à effectuer pour ce candidat.
		</p>

		<o-sticker
			v-for="task in setup.orderedTasks"
			:key="task.id"
			:class="{ 'temp-worker-task-list__sticker--passed' : task.isPassed }">
			<div class="flex fd-c g-sm">
				<div class="flex ai-c jc-sb g-xs">
					<div class="flex ai-c g-xs">
						<o-icon
							class="temp-worker-task-list__sticker-task-icon"
							:font-icon="task.icon"/>
						<h5 class="mb-0">{{ task.title }}</h5>
					</div>
					<div class="flex ai-c g-sm">
						<o-icon
							ripple="info"
							font-icon="icon-interface-edit-pencil"
							@click="task.openModalEdit()"/>
						<o-pop-confirm @confirm="task.deleteAsync()">
							<o-icon
								ripple="danger"
								font-icon="icon-interface-delete-bin-2"/>
						</o-pop-confirm>
					</div>
				</div>

				<div>{{ task.description }}</div>

				<div class="flex ai-c g-xs">
					<o-avatar
						v-tooltip="`${task.assignedUserLastName} ${task.assignedUserFirstName}`"
						:name="task.assignedUserLastName"
						:avatar="task.assignedUserAvatarId"
						:size="24"
						root-url="/app/avatar/"/>
					<div>
						<span
							v-if="task.startDate"
							:class="task.isPassed ? 'text--warging' : 'text--info'">
							<o-icon font-icon="icon-interface-time-clock-circle"/>
							{{ task.startDate.toReadable('$DD.$MM.$YYYY à $hhh$mm') }} - Durée {{ task.readableDuration }}
						</span>
					</div>
				</div>
			</div>
		</o-sticker>
	</o-section>
</template>

<script setup lang="ts">
import TempWorkerTaskListSetupService from '@/setup/temp-worker/TempWorkerTaskListSetupService';
const props = defineProps(TempWorkerTaskListSetupService.props);
const setup = new TempWorkerTaskListSetupService(props);
</script>

<style scoped lang="less">
.temp-worker-task-list {
  :deep(.orion-section__header) {
    align-items: center;
  }

	&__empty-text {
		font-style: italic;
		color: var(--grey-dark);

		&-arrow {
      float: right;
			font-size: 1.5rem;
      transform: translate(-70%, -50%);
		}
	}

	&__toggle {
		margin-bottom: 1rem;
	}

	&__sticker {
		&--passed {
			opacity: 0.4;

			&:hover {
				opacity: 1;
			}
		}

		&-task-icon {
			background: rgba(var(--rgb-grey-light), 0.3);
			padding: 0.25rem;
			border-radius: 0.25rem;
		}
	}
}
</style>
